"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseOffset = exports.calculateRelativeValue = exports.calculateAnchorPosition = void 0;
/**
 * Вычисляет относительное значение центра полигона к изображению генплана
 * @param value
 * @param containerSize
 * @param scale
 * @returns
 */
const calculateRelativeValue = (value, containerSize, scale) => value * scale / containerSize * 100;

/**
 * Парсит значение отступа в строку
 *
 * @param offset - отступ
 */
exports.calculateRelativeValue = calculateRelativeValue;
const parseOffset = offset => {
  const sign = offset < 0 ? '-' : '+';
  return `${sign} ${Math.abs(offset)}`;
};

/**
 * Вычисляет положение точки-якоря, относительно которой позиционируется попап, на основе состояния картинки
 *
 * @param polygonCenter - центр полигона объекта, относительно которого позиционируем попап
 * @param containerSize - размер изображения генплана
 * @param transform - текущий сдвиг и масштаб изображения
 */
exports.parseOffset = parseOffset;
const calculateAnchorPosition = function (polygonCenter, containerSize) {
  let transform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    x: 0,
    y: 0,
    scale: 1
  };
  const [x, y] = polygonCenter;
  const {
    width,
    height
  } = containerSize;
  const relativeX = calculateRelativeValue(x, width, transform.scale);
  const relativeY = calculateRelativeValue(y, height, transform.scale);
  const xOffset = parseOffset(transform.x);
  const yOffset = parseOffset(transform.y);
  return {
    left: `${relativeX}% ${xOffset}px`,
    top: `${relativeY}% ${yOffset}px`
  };
};
exports.calculateAnchorPosition = calculateAnchorPosition;